import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@app/src/material.module';
import { AuthCallbackComponent } from '@app/services/auth/auth-callback.component';

@NgModule({
  declarations: [
    AuthCallbackComponent
  ],
  exports:[ 
    AuthCallbackComponent,
  ],
  imports: [
    MaterialModule,
    CommonModule
  ]
})
export class AuthCallbackModule { }